import { FinancialReviewRowDTO } from '../types/FinancialDTO';

export const visibleSelection = (selected: number[], visible: number[]) => selected.filter(id => visible.includes(id));

export const matchesCheckedFilter = (checked: boolean, filter: string) => filter !== 'CHECKED' || checked;

export const matchesReviewFilter = (row: FinancialReviewRowDTO, checkedFilter: string, onlyDifferent: boolean) =>
	matchesCheckedFilter(row.checked, checkedFilter) && (!onlyDifferent || Math.abs(row.difference) >= 0.005);

const byName = (a: FinancialReviewRowDTO, b: FinancialReviewRowDTO) => (a.companyName || '').localeCompare(b.companyName || '');

const sortValue = (row: FinancialReviewRowDTO, key: string) => {
	if (key === 'PREVIOUS') {
		return row.previous ? row.previous.value || 0 : null;
	}
	if (key === 'CURRENT') {
		return row.current ? row.current.value || 0 : null;
	}
	return row.difference;
};

export const compareReviewRows = (a: FinancialReviewRowDTO, b: FinancialReviewRowDTO, key: string, ascending: boolean) => {
	const direction = ascending ? 1 : -1;
	if (key === 'NAME') {
		return direction * byName(a, b);
	}
	const first = sortValue(a, key);
	const second = sortValue(b, key);
	if (first === null || second === null) {
		return first === second ? byName(a, b) : first === null ? 1 : -1;
	}
	return direction * (first - second) || byName(a, b);
};
